// no-op
// this file exists in case a target needs to add logic to the top of the index file in an
// override.
export default undefined